import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_pos-r _bgc--white _rounded--common gfu-background-swept _py-2 _px-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_skeleton_line, { height: 33 })
  ]))
}